// extracted by mini-css-extract-plugin
module.exports = {"HowItWorks":"HowItWorks_HowItWorks__a0lTZ","tooltips":"HowItWorks_tooltips__76eQP"};